import type { ProviderTrafficPoint } from '../../data/providerTraffic';

interface TrafficSegment {
  sku: string;
  requests: number;
}

export interface TrafficDay {
  key: string;
  date: Date;
  total: number;
  segments: TrafficSegment[];
}

const utcDayKey = (date: Date): string => date.toISOString().slice(0, 10);

export const providerTrafficDays = (
  points: ProviderTrafficPoint[],
  anchor = new Date(),
  length = 30,
): TrafficDay[] => {
  const byDay = new Map<string, Map<string, number>>();
  for (const point of points) {
    const key = utcDayKey(new Date(point.t));
    const endpoints = byDay.get(key) ?? new Map<string, number>();
    for (const endpoint of point.endpoints) {
      endpoints.set(endpoint.sku, (endpoints.get(endpoint.sku) ?? 0) + endpoint.requests);
    }
    byDay.set(key, endpoints);
  }

  const end = new Date(Date.UTC(
    anchor.getUTCFullYear(), anchor.getUTCMonth(), anchor.getUTCDate(),
  ));
  return Array.from({ length }, (_, index) => {
    const date = new Date(end);
    date.setUTCDate(end.getUTCDate() - (length - index - 1));
    const key = utcDayKey(date);
    const segments = [...(byDay.get(key) ?? new Map()).entries()]
      .map(([sku, requests]) => ({ sku, requests }))
      .filter((segment) => segment.requests > 0)
      .sort((a, b) => b.requests - a.requests || a.sku.localeCompare(b.sku));
    return {
      key,
      date,
      segments,
      total: segments.reduce((sum, segment) => sum + segment.requests, 0),
    };
  });
};
